import { render, staticRenderFns } from "./contract-review-card.vue?vue&type=template&id=48f702cc&scoped=true"
import script from "./contract-review-card.vue?vue&type=script&lang=js"
export * from "./contract-review-card.vue?vue&type=script&lang=js"
import style0 from "./contract-review-card.vue?vue&type=style&index=0&id=48f702cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f702cc",
  null
  
)

export default component.exports